module.exports = __webpack_public_path__ + "static/media/water-treatment.2c6d2f50.svg";